import states from '../../configs/states';

export const EXCHANGE_AND_PROGRAMS_NAMES = {
    [states.IDAHO]: {
        en: {
            exchangeName: 'Your Health Idaho',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP'
        },
        es: {
            exchangeName: 'Your Health Idaho',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP'
        },
    },
    [states.NEVADA]: {
        en: {
            exchangeName: 'Nevada Health Link',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP'
        },
        es: {
            exchangeName: 'Nevada Health Link',
            exchangeMedicaid: 'Seguro de enfermedad',
            exchangeChip: 'CHIP'
        },
    },
    [states.NEW_JERSEY]: {
        en: {
            exchangeName: 'GetCoveredNJ',
            exchangeMedicaid: 'NJ FamilyCare',
            exchangeChip: 'NJ FamilyCare'
        },
        es: {
            exchangeName: 'GetCoveredNJ',
            exchangeMedicaid: 'NJ FamilyCare',
            exchangeChip: 'NJ FamilyCare'
        },
    },
    [states.PENNSYLVANIA]: {
        en: {
            exchangeName: 'Pennie',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP'
        },
        es: {
            exchangeName: 'Pennie',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP'
        },
    },
    [states.VIRGINIA]: {
        en: {
            exchangeName: 'Virginia\'s Insurance Marketplace',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'FAMIS'
        },
        es: {
            exchangeName: 'Virginia\'s Insurance Marketplace',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'FAMIS'
        },
    },
    [states.GEORGIA]: {
        en: {
            exchangeName: 'Georgia Access',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'PeachCare for Kids(R)'
        },
        es: {
            exchangeName: 'Georgia Access',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'PeachCare para Niños(R)'
        },
    },
    [states.NEW_MEXICO]: {
        en: {
            exchangeName: 'TBD',
            exchangeMedicaid: 'TBD',
            exchangeChip: 'TBD'
        },
        es: {
            exchangeName: 'TBD',
            exchangeMedicaid: 'TBD',
            exchangeChip: 'TBD'
        },
    },
    [states.MINNESOTA]: {
        en: {
            exchangeName: 'MNSure',
            exchangeMedicaid: 'Medical Assistance',
            exchangeChip: 'MinnesotaCare'
        },
        es: {
            exchangeName: 'MNSure',
            exchangeMedicaid: 'Medical Assistance',
            exchangeChip: 'MinnesotaCare'
        },
    },
    [states.ILLINOIS]: {
        en: {
            exchangeName: 'TBD',
            exchangeMedicaid: 'TBD',
            exchangeChip: 'TBD'
        },
        es: {
            exchangeName: 'TBD',
            exchangeMedicaid: 'TBD',
            exchangeChip: 'TBD'
        },
    },
};